<template>
  <footer class="app-footer">
  	<div style="text-align:center;display:inline;margin-left: 300px;"><span style="color:#ff7000">©</span> xpressbees.</div>
    <div style="float:right"><span style="color:#ff7000">Version:</span> V3.6</div>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?dc7ce482